import styled from 'styled-components'

const Container = styled.div`
  position: absolute;
  background-color: var(--color-white);
  padding: 40px 40px;
  outline: none;
  max-width: 90vw;
  min-width: 500px;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Title = styled.p`
  color: var(--color-oxford-blue);
  text-align: center;
  margin-bottom: 8px;
  word-break: break-word;

  font-weight: bold;
  font-size: 24px;
`

const SubTitle = styled.p`
  font-size: 16px;
  color: var(--color-text-secondary);
  text-align: center;
`

const IconWrap = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
`

const ButtonsWrap = styled.div`
  margin-top: 0.5rem;
  display: flex;
  gap: 8px;
`

export const ResourceWrap = styled.div`
  width: 100%;
  //display: flex;
  //flex-direction: column;
  //gap: 8px;
    padding: 10px;
  margin-bottom: 0.5rem;
  max-height: 90vh;
  overflow: auto;
    
`

export { Container, Title, SubTitle, IconWrap, ButtonsWrap }
